/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Metrics_Section_DisplayInputs */



/**
* | output |
* | --- |
* | "Editor List Display" |
*
* @param {Options_Metrics_Section_DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_metrics_section_display = /** @type {((inputs?: Options_Metrics_Section_DisplayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Metrics_Section_DisplayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Editor List Display")
	if (locale === "de") return /** @type {LocalizedString} */ ("Editor List Display")
	if (locale === "it") return /** @type {LocalizedString} */ ("Editor List Display")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Editor List Display")
	if (locale === "es") return /** @type {LocalizedString} */ ("Editor List Display")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Editor List Display")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Editor List Display")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Editor List Display")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Editor List Display")
	return /** @type {LocalizedString} */ ("Editor List Display")
});